import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowRightOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileArrowRightOut"><Path d="M21.3105 19L17.25 23.0605L16.1895 22L18.4395 19.75H12V18.25H18.4395L16.1895 16L17.25 14.9395L21.3105 19Z" fill="currentColor"/><Path d="M12 10H20V15.5684L17.25 12.8184L14.0684 16L14.8184 16.75H10.5V22H4.75C4.33579 22 4 21.6642 4 21.25V2.75C4 2.33579 4.33579 2 4.75 2H12V10Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowRightOut;
